import { TabList } from "src/shared/components/navigation/tab-menu/TabMenu.types"

export const mantenimientosDetailTabs: TabList[] = [
    { label: "Información general", path: "general" },
    { label: "Comentarios", path: "comentarios" },
]
